<template>
  <div v-if="nonMemberInfo">
    <table class="board-write type-block--mobile">
      <caption>
        개인정보작성
      </caption>
      <tbody>
        <!-- 성명 -->
        <tr>
          <th scope="row">
            Name <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="userName" class="sr-only">Name</label>
            <div class="layout-flex-row">
              <input
                ref="userNameRef"
                v-model="nonMemberInfo.userName"
                type="text"
                id="userName"
                placeholder=""
                class="board-write__input"
              />
            </div>
          </td>
        </tr>
        <!-- 이메일 -->
        <tr>
          <th scope="row">
            Email <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="email" class="sr-only">Email</label>
            <input
              ref="emailRef"
              v-model="nonMemberInfo.email"
              type="text"
              id="email"
              placeholder=""
              class="board-write__input"
            />
          </td>
        </tr>
        <!-- 연락처 -->
        <tr>
          <th scope="row">
            Phone Number
            <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="phone" class="sr-only">Phone Number</label>
            <input
              ref="phoneRef"
              v-model="nonMemberInfo.phone"
              type="text"
              id="phone"
              placeholder=""
              class="board-write__input"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <section class="section-accordion__wrap type-bullet type-top-narrow">
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            aria-controls="panel-1"
            id="accordion-trigger-1"
          >
            <span class="section-accordion__num" aria-hidden="true"></span>
            <span class="section-accordion__title"
              >Privacy Policy(Required)</span
            >
          </button>
        </h3>
        <div
          id="panel-1"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-1"
        >
          <div
            class="section-accordion__content section-accordion__agree__wrap"
          >
            <div class="section-accordion__agree__inner">
              <p class="section-accordion__desc">
                KISA(Korea Internet & Security Agency) collects and utilizes
                only the minimum necessary personal information for providing
                the Bug Bounty Programs services.
              </p>
              <ol>
                <li class="section-accordion__desc">
                  1. Purpose of collecting personal information
                </li>
                <li class="section-accordion__desc">
                  - Operation of Bug Bounty Program services
                </li>
                <li class="section-accordion__desc">
                  2. Personal information collected
                </li>
                <li class="section-accordion__desc">
                  - Required Information : Name, Email, Phone number
                </li>
                <li class="section-accordion__desc">
                  3. Period of Collection and Use of Personal Information : 1
                  year
                </li>
                <li class="section-accordion__desc">
                  ※ You have the right to refuse the collection, use, and
                  handling consignment of the above personal information.
                  However, the use of the Bug Bounty Program services may be
                  restricted.
                </li>
              </ol>
            </div>
            <div class="section-accordion__agree">
              <p class="section-accordion__agree__desc">
                agree for Personal Information Collection and Use
              </p>
              <div class="chk__wrap">
                <label class="chk chk--circle">
                  <input
                    ref="privateYnTmpRef"
                    type="radio"
                    name="privateYnTmp"
                    v-model="nonMemberInfo.privateYnTmp"
                    :value="false"
                  />I Disagree
                </label>
                <label class="chk chk--circle">
                  <input
                    ref="privateYnTmpRef"
                    type="radio"
                    name="privateYnTmp"
                    v-model="nonMemberInfo.privateYnTmp"
                    :value="true"
                  />I Agree
                </label>
              </div>
            </div>
          </div>
        </div>
      </article>
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            aria-controls="panel-1"
            id="accordion-trigger-1"
          >
            <span class="section-accordion__num" aria-hidden="true"></span>
            <span class="section-accordion__title"
              >Privacy Policy(Optional)</span
            >
          </button>
        </h3>
        <div
          id="panel-1"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-1"
        >
          <div
            class="section-accordion__content section-accordion__agree__wrap"
          >
            <div class="section-accordion__agree__inner">
              <p class="section-accordion__desc">
                KISA(Korea Internet & Security Agency) collects and utilizes
                only the minimum necessary personal information for providing
                the Bug Bounty Programs services.
              </p>
              <ol>
                <li class="section-accordion__desc">
                  1. Purpose of collecting personal information
                </li>
                <li class="section-accordion__desc">- Souvenir provision</li>
                <li class="section-accordion__desc">
                  2. Personal information collected
                </li>
                <li class="section-accordion__desc">
                  - Optional information : Affiliation, Address
                </li>
                <li class="section-accordion__desc">
                  3. Period of Collection and Use of Personal Information : 1
                  year
                </li>
                <li class="section-accordion__desc">
                  ※ You have the right to refuse the collection, use, and
                  handling consignment of the above personal information.
                  However, the use of the Bug Bounty Program services may be
                  restricted.
                </li>
              </ol>
            </div>
            <div class="section-accordion__agree">
              <p class="section-accordion__agree__desc">
                agree for Personal Information Collection and Use
              </p>
              <div class="chk__wrap">
                <label class="chk chk--circle">
                  <input
                    ref="privateYnRewardRef"
                    type="radio"
                    name="privateYnReward"
                    v-model="nonMemberInfo.privateYnReward"
                    :value="false"
                  />I Disagree
                </label>
                <label class="chk chk--circle">
                  <input
                    ref="privateYnRewardRef"
                    type="radio"
                    name="privateYnReward"
                    v-model="nonMemberInfo.privateYnReward"
                    :value="true"
                  />I Agree
                </label>
              </div>
            </div>
          </div>
        </div>
      </article>
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            aria-controls="panel-1"
            id="accordion-trigger-1"
          >
            <span class="section-accordion__num" aria-hidden="true"></span>
            <span class="section-accordion__title"
              >Agreement of Providing Personal Information to a Third
              Party(Optional)</span
            >
          </button>
        </h3>
        <div
          id="panel-1"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-1"
        >
          <div
            class="section-accordion__content section-accordion__agree__wrap"
          >
            <div class="section-accordion__agree__inner">
              <p class="section-accordion__desc">
                KISA(Korea Internet & Security Agency) collects and utilizes
                only the minimum necessary personal information for providing
                the bug Bounty Programs services.
              </p>
              <ol>
                <li class="section-accordion__desc">
                  1. Organization receiving personal information: Joint
                  operating companies for the Bug Bounty Program
                  <a
                    href="https://knvd.krcert.or.kr/overview/operation/intro"
                    target="_blank"
                    rel="noopener noreferrer"
                    >https://knvd.krcert.or.kr/overview/operation/intro</a
                  >
                </li>
                <li class="section-accordion__desc">
                  2. Purpose of using personal information: Joint operation of
                  the Bug Bounty Program
                </li>
                <li class="section-accordion__desc">
                  3. Personal Information Items to be Provided: Name, Email,
                  Phone number, affiliation, address
                </li>
                <li class="section-accordion__desc">
                  4. Period of Collection and Use of Personal Information : 1
                  year
                </li>
              </ol>
              <p class="section-accordion__desc">
                ※ You have the right to refuse the collection, use, and handling
                consignment of the above personal information. However, the use
                of the Bug Bounty Program service and souvenir provision may be
                restricted.
              </p>
            </div>
            <div class="section-accordion__agree">
              <p class="section-accordion__agree__desc">
                agree for Personal Information Collection and Use
              </p>
              <div class="chk__wrap">
                <label class="chk chk--circle">
                  <input
                    ref="privateThirdYnRef"
                    type="radio"
                    name="privateThirdYn"
                    v-model="nonMemberInfo.privateThirdYn"
                    :value="false"
                  />I Disagree
                </label>
                <label class="chk chk--circle">
                  <input
                    ref="privateThirdYnRef"
                    type="radio"
                    name="privateThirdYn"
                    v-model="nonMemberInfo.privateThirdYn"
                    :value="true"
                  />I Agree
                </label>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>
    <div class="btn__wrap type-bottom-board">
      <button
        type="button"
        class="btn btn--l btn--blue"
        @click="triggerClickToTab()"
      >
        Next
        <span aria-hidden="true"
          ><img src="@/assets/img/icon_arrow_right.svg" alt=""
        /></span>
      </button>
    </div>
  </div>
</template>

<script>
import reportHandler from "../../ReportHandler.js";
import { ref, inject, watch } from "vue";
export default {
  props: {
    modelValue: { type: Object, required: true },
  },
  setup(props, { emit }) {
    const lodash = inject("lodash");

    // data 정의
    const nonMemberInfo = ref(lodash.cloneDeep(props.modelValue.personal));

    // 각 입력 필드 ref 선언 (포커스용)
    const userNameRef = ref(null);
    const userEngNameRef = ref(null);
    const emailRef = ref(null);
    const phoneRef = ref(null);
    const privateYnTmpRef = ref(null);
    const privateYnRewardRef = ref(null);
    const privateThirdYnRef = ref(null);

    // methods 정의
    const triggerClickToTab = () => {
      const result = reportHandler.triggerClickToTabForeign(
        1,
        nonMemberInfo.value
      );
      if (typeof result === "string") {
        focusInput(result);
        return;
      }
      emit("changeTab", 1);
    };
    // 입력 포커스 기능
    const focusInput = (key) => {
      const refMap = {
        userName: userNameRef,
        userEngName: userEngNameRef,
        email: emailRef,
        phone: phoneRef,
        privateYnTmp: privateYnTmpRef,
        privateYnReward: privateYnRewardRef,
        privateThirdYn: privateThirdYnRef,
      };
      const refObj = refMap[key];
      if (refObj && refObj.value) {
        refObj.value.focus();
      }
    };
    // watch 정의
    watch(
      nonMemberInfo,
      (newVal) => {
        emit("update:modelValue", {
          ...props.modelValue,
          personal: newVal,
        });
      },
      { deep: true }
    );

    // html에서 사용될 데이터 정의
    return {
      nonMemberInfo,
      triggerClickToTab,
      focusInput,
      userNameRef,
      userEngNameRef,
      emailRef,
      phoneRef,
      privateYnTmpRef,
      privateYnRewardRef,
      privateThirdYnRef,
    };
  },
};
</script>

<style>
</style>